import { Suspense } from "react";
import { Route, Routes } from "react-router";

import { PageLoading } from "~/components/loading";
import { AreaInputContainer } from "./components/areaInput.container";
import { RecordGeoItemCreate } from "./components/RecordGeoItemCreate";
import { RecordGeoItemCreateWithOverlay } from "./components/RecordGeoItemCreateWithOverlay";
import { RecordGeoItemEdit } from "./components/RecordGeoItemEdit";

/** Record-scoped area routes. Record-less `/area-input/create` lives in `features/geoItems`. */
export function AreaInputRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path=":recordId/create" element={<RecordGeoItemCreate />} />
        {/* Path mirrors the canonical typed route (v2Route.areaInput.record.createWithOverlayImg). */}
        <Route path=":recordId/create-with-overlay" element={<RecordGeoItemCreateWithOverlay />} />
        <Route path=":recordId/:geoItemId/edit" element={<RecordGeoItemEdit />} />
        <Route path=":recordId" element={<AreaInputContainer />} />
        <Route path=":recordId/:geoItemId" element={<AreaInputContainer />} />
      </Routes>
    </Suspense>
  );
}
